<template>
  <div class="base">
    <inside-header title="提现记录" />
    <div class="main">
      <div class="list">
        <div v-for="(count, index) in 5" :key="index" class="item">
          <a-row class="record">
            <a-col :span="18" class="info">
              <div class="title">
                提现-支付宝
              </div>
              <div class="time">
                <span>2月6日</span>
                <span>17:33</span>
              </div>
            </a-col>
            <a-col :span="6" class="money">
              <div class="total">
                -300.00
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
  },
  methods: {
    // this.loadData(this.id, this.$route.query)
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

    .list {
      .item {
        .record {
          height: 80px;
          padding: 15px 5px 15px 0px;

          .info {

            .title {
              font-family: PingFang-SC-Medium;
              font-size: 16px;
              line-height: 25px;
              color: #333333;
            }

            .time {
              font-family: PingFang-SC-Medium;
              font-size: 14px;
              line-height: 28px;
              color: #999;

              span:nth-child(2) {
                margin-left: 5px;
              }
            }
          }

          .money {
            .total {
              font-family: PingFang-SC-Bold;
              font-size: 16px;
              line-height: 50px;
              color: #333333;
            }
          }
        }
      }
    }
  }
</style>
